module.exports = __webpack_public_path__ + "img/w-explore-sao.3df49ca5.svg";